module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-image.svg?h=0782c94c7a5aa79683049d1a33d72811";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-image.svg
// module id = 2045
// module chunks = 12 15